import { render, staticRenderFns } from "./Forwarders.vue?vue&type=template&id=551292f2"
import script from "./Forwarders.vue?vue&type=script&lang=js"
export * from "./Forwarders.vue?vue&type=script&lang=js"
import style0 from "./Forwarders.vue?vue&type=style&index=0&id=551292f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports